import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
// import { Link } from "gatsby"
// import { slide as SlideMenu } from "react-burger-menu"
import { push as SlideMenu } from "react-burger-menu";
import MenuIcon from "../images/MenuIcon";
import SocialLinks from "./SocialLinks";

// The styling for the button element underneath everything is not exposed.
// See the file in the node_module, /react-burger-menu/lib/BurgerIcon.js
const menuStyles = {
  bmBurgerButton: {
    position: "fixed",
    right: 20,
    width: "24px",
    height: "auto",
    outline: "none",
    zIndex: 40,
    marginTop: "18px",
  },
  bmBurgerBars: {
    background: "white",
    borderRadius: 2,
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "28px",
    width: "28px",
  },
  bmCross: {
    background: "#bdc3c7",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%",
    top: 0,
  },
  bmMenu: {
    background: "black",
    padding: "2.5em 1.5em 0",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "#b8b7ad",
    padding: "0.8em",
  },
  bmItem: {
    display: "inline-block",
    paddingTop: 8,
    textAlign: "center",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.3)",
    // background: "none"
  },
};

const Menu = (props) => {
  const { 
    handleToggle = () => {},
    hidden = false,
  } = props;
  return (

    <SlideMenu
      className="burger-menu"
      right
      onStateChange={(state) => {
        handleToggle(state);
      }}
      styles={menuStyles}
      customBurgerIcon={
        <MenuIcon
          style={{ outline: "none" }}
          className="lg:hidden"
        />

      }
      outerContainerId="outer-container"
      pageWrapId="page-wrap"
      burgerButtonClassName={`${hidden ? "hidden" : ''}`}
    >

      {/*
      <Link to="/" className="menu-item w-full outline-none select-none">
        Home
      </Link>
      */}
      {/*
        <p
        id="about"
        className="menu-item w-full outline-none select-none"
        href="/about"
      >
        About
      </p>
      <p
        id="contact"
        className="menu-item w-full outline-none select-none"
        href="/contact"
      >
        Contact
      </p>
      */}

      {/* <Link
        to="/dashboard"
        className="menu-item w-full outline-none select-none font-bold hover:text-primary"
      >
        Log in
      </Link> */}

      <a
        href={`${
          // eslint-disable-next-line no-negated-condition
          typeof window !== "undefined" ? window.origin : ""
        }/dashboard`}
        className="menu-item  w-full outline-none select-none hover:text-primary border-b pb-3 mb-3 border-gray-900"
      >
        <i className="fa fa-credit-card mr-2" /> Sign in
      </a>
      <Link
        to="/ai"
        className="menu-item w-full outline-none select-none hover:text-primary"
      >
        TomoAI
      </Link>

      <a
        href="https://tomocredit.com/blog/"
        className="menu-item w-full outline-none select-none hover:text-primary"
      >
        Blog
      </a>

      <Link
        to="/faq"
        className="menu-item w-full outline-none select-none hover:text-primary"
      >
        FAQs
      </Link>

      <Link
        to="/about"
        className="menu-item w-full outline-none select-none hover:text-primary"
      >
        About
      </Link>

      <SocialLinks className="w-full" />
    </SlideMenu>
  );

};

Menu.propTypes = {
  handleToggle: PropTypes.func,
  hidden: PropTypes.bool,
};

export default Menu;
